import React from "react";
import ReactHtmlParser from 'react-html-parser'; 

function SkimTest({ headline, displayFormula }) {
  const text = () => {
    let t = headline;
    let first = t.split(' ').splice(0, 4).join(' ');
    let last = t.split(' ').splice(-4, 4).join(' ');
    let middle = t.replace(first, '').replace(last, '');

    return (
      '<span class="hafirst-four"><small>First Four Words</small>' +
      first +
      '</span>' +
      middle +
      '<span class="halast-four"><small>Last Four Words</small>' +
      last +
      '</span>'
    );
  };

  return (
    <div className={displayFormula ? 'py-5 px-sm-5' : 'py-5 px-sm-5 bg-light'}>
      <div className="container">
        <div className="row">
          <div className="col-1" />
          <div className="col-10">
            <h1 className="pb2 font-weight-bold text-center">
              Your Linkedin Headline's "Skim Test"
            </h1>
            <h6 className="text-center mb-5">
              When skimming content, most people will see the first four words
              and the last four words of a Headline.
            </h6>
            <h4 className="font-weight-bold text-center p-1">
              {ReactHtmlParser(text())}
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SkimTest;